import React from 'react';

const AsyncPrintAd = React.lazy(() => import('./PrintAdContainer'));

export const PrintAdPage = () => {
  return <AsyncPrintAd />;
};
